export default {
  namespaced: true,
  state: {
    create: false,
    type: 'stream',
    roomKey: '',
    deviceId: ''
  },
  getters: {
    getCreate ({ create }) {
      return create
    },
    getType ({ type }) {
      return type
    },
    getRoomKey ({ roomKey }) {
      return roomKey
    },
    getDevice ({ deviceId }) {
      return deviceId
    }
  },
  mutations: {
    setCreate (state, create) {
      state.create = create
    },
    setType (state, type) {
      state.type = type
    },
    setRoomKey (state, roomKey) {
      state.roomKey = roomKey
    },
    setDevice (state, deviceId) {
      state.deviceId = deviceId
    }
  }
}
